import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton, TextField, ContextualMenu } from '@fluentui/react';
import React from 'react';

interface DialogConfirmDeleteProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  message: string;
  confirmWord?: string;
  confirmText: string;
  cancelText: string;
}

const DialogConfirmDelete: React.FC<DialogConfirmDeleteProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmWord,
  confirmText,
  cancelText,
}) => {
  const [typed, setTyped] = React.useState(false);

  React.useEffect(() => {
    if (!isOpen) {
      setTyped(false);
    }
  }, [isOpen]);

  return (
    <Dialog
      hidden={!isOpen}
      dialogContentProps={{
        type: DialogType.normal,
        title,
      }}
      modalProps={{
        isBlocking: true,
        dragOptions: {
          moveMenuItemText: 'Move',
          closeMenuItemText: 'Close',
          menu: ContextualMenu,
        },
      }}
      onDismiss={onCancel}
      minWidth={380}
    >
      <div>
        {message}
        <br />
        <br />
      </div>

      {confirmWord && <TextField type="text" autoFocus onChange={(e, value) => setTyped(value === confirmWord)} />}

      <DialogFooter>
        <PrimaryButton onClick={onConfirm} text={confirmText} disabled={!!confirmWord && !typed} />
        <DefaultButton onClick={onCancel} text={cancelText} />
      </DialogFooter>
    </Dialog>
  );
};

export default DialogConfirmDelete;
